// extracted by mini-css-extract-plugin
export default {"container":"languageSelector_container__lCMHp","innerContainer":"languageSelector_innerContainer__hAr9o","flag":"languageSelector_flag__NM0DZ"};